import type { AspectRatioOption, AspectRatioWithTolerance } from "@lib/mediaLibrary";

/** Used for more fine-tuned choices, like when you want to have separate tolerances for each aspect ratio */
export const getCustomAspectRatioOptions = (aspectRatios: AspectRatioWithTolerance[]): AspectRatioOption[] => {
  return aspectRatios.map((aspectRatio) => {
    return {
      // This format is a little odd, admittedly, but it allows us to encode the ratio & tolerance
      // together in one parameter, so that each aspect ratio can have an individual tolerance
      value: `${aspectRatio.aspectRatioDecimal};${aspectRatio.tolerance || "0.1"}`,
      label: aspectRatio.label,
    };
  });
};
